import { render } from "./ViewRemoveWorldCity.vue?vue&type=template&id=37c360e9&scoped=true"
import script from "./ViewRemoveWorldCity.vue?vue&type=script&lang=js"
export * from "./ViewRemoveWorldCity.vue?vue&type=script&lang=js"

import "./ViewRemoveWorldCity.vue?vue&type=style&index=0&id=37c360e9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c360e9"]])

export default __exports__